import { OfferAudiencesComponent } from './components/company-offers/offer-audiences.component';
import { VendorExportHealthComponent } from './components/contentadmin/vendor-pending-transfers-page/vendor-export-health.component';
import {UserProductsComponent} from './components/modal/adduserdialog/user-products.component';
import { CredentialContext, CredentialRefresh } from './services/session/credential-transition';
import { CREDENTIAL_REQUEST, CredentialRestangularHttp } from './services/session/credential-request';
import { MonthlyTopupScheduleComponent } from './components/monthly-topup-schedule/monthly-topup-schedule.component';
import {APP_INITIALIZER, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { VersionGateDialogComponent } from './services/version-policy/version-gate-dialog.component';

// Angular Material Components
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Restangular, RestangularModule, RestangularHttp } from 'ngx-restangular';
import { AppSettings } from './app.settings';
import {RESTANGULAR_INTEGRATION_SERVER} from './integration-restangular.token';
import { TabStorageService } from './services/tabstorage/tabstorage.service';
import { AdManagerComponent } from './components/admanager/admanager.component';
import { AnalyticsComponent } from './components/analytics/analytics.component';
import { CategoriesComponent } from './components/categories/categories.component';
import { HomeComponent } from './components/home/home.component';
import { InvitationsComponent } from './components/invitations/invitations.component';
import { LoginComponent } from './components/login/login.component';
import { ManageMembersComponent } from './components/managemembers/managemembers.component';
import { ManageWellspaceComponent } from './components/managewellspace/managewellspace.component';
import { MyTeamComponent } from './components/my-team/my-team.component';
import { TeamSummaryComponent } from './components/team-summary/team-summary.component';
import { ManageWellspaceProductsComponent } from './components/managewellspace/managewellspace-products/managewellspace-products.component';
import { ConfirmDialogComponent } from './components/modal/confirmdialog/confirmdialog.component';
import { AllowanceFundingAmountDialogComponent } from './components/modal/allowancefundingamountdialog/allowance-funding-amount-dialog.component';
import { EnterPinDialogComponent } from './components/modal/enterpindialog/enterpindialog.component';
import { FieldInputDialogComponent } from './components/modal/fieldinputdialog/fieldinputdialog.component';
import { MemberRewardDialogComponent } from './components/modal/memberrewarddialog/memberrewarddialog.component';
import { TeamOneTimeRewardComponent } from './components/modal/onetimerewarddialog/team-one-time-reward.page';
import { PlanComponent } from './components/plan/plan.page';
import { ProfileComponent } from './components/profile/edit-profile.page';
import { SettingsAndPermissionsComponent } from './components/settingsandpermissions/settingsandpermissions.component';
import { StripecreditcardPageComponent } from './components/stripe-creditcard/stripecreditcard.page';
import { TeamAddMembersPageComponent } from './components/team-add-members/team-add-members.page';
import { TeamMemberSelectorComponent } from './components/team-member-selector/team-member-selector.component';
import {
  TaxableFilterPipe,
  TeamSetBenefitsPageComponent,
} from './components/team-set-benefits/team-set-benefits.page';
import { TeameditComponent } from './components/teamedit/teamedit.component';
import { TeampaymentsComponent } from './components/teampayments/teampayments.component';
import { UserItemComponent } from './components/user-item/user-item.component';
import { MemberProductEligibilityDialogComponent } from './components/modal/member-product-eligibility-dialog/member-product-eligibility-dialog.component';

import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { MatTableExporterModule } from 'mat-table-exporter';
import { WebdatarocksPivotModule } from 'ng-webdatarocks';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AdvertisingAdsComponent } from './components/advertising-ads/advertising-ads.component';
import { AdvertisingAdvertisersComponent } from './components/advertising-advertisers/advertising-advertisers.component';
import { AdvertisingCampaignsComponent } from './components/advertising-campaigns/advertising-campaigns.component';
import { AdvertisingCreativesComponent } from './components/advertising-creatives/advertising-creatives.component';
import { AdvertisingFlightsComponent } from './components/advertising-flights/advertising-flights.component';
import { AdvertisingImpressionsComponent } from './components/advertising-impressions/advertising-impressions.component';
import {
  AnalyticsApproveComponent,
  GetStatePipe,
} from './components/analytics/analytics-approve/analytics-approve.component';
import { AnalyticsCategoriesComponent } from './components/analytics/analytics-categories/analytics-categories.component';
import { AnalyticsConfigureComponent } from './components/analytics/analytics-configure/analytics-configure.component';
import { AnalyticsMembersComponent } from './components/analytics/analytics-members/analytics-members.component';
import { AnalyticsOverviewComponent } from './components/analytics/analytics-overview/analytics-overview.component';
import {
  AnalyticsReimbursementsComponent,
  GetSenderNameReimbursements,
  GetUserNameReimbursements,
} from './components/analytics/analytics-reimbursements/analytics-reimbursements.component';
import {
  AnalyticsToapproveComponent,
  GetStatusPipe,
} from './components/analytics/analytics-toapprove/analytics-toapprove.component';
import { BillingComponent } from './components/billing/billing.component';
import { FileuploadComponent } from './components/fileupload/fileupload.component';
import { InsuranceBrokersComponent } from './components/insurance-brokers/insurance-brokers.component';
import { InsuranceCarriersComponent } from './components/insurance-carriers/insurance-carriers.component';
import { InsuranceEmployersComponent } from './components/insurance-employers/insurance-employers.component';
import { InsuranceUsersComponent } from './components/insurance-users/insurance-users.component';
import { IntegrationHomeComponent } from './components/integrationhome/integrationhome.component';
import { MediaContentComponent } from './components/media-content/media-content.component';
import { MediaDocumentsComponent } from './components/media-documents/media-documents.component';
import { MediaImagesComponent } from './components/media-images/media-images.component';
import {
  AddEditDialogComponent,
  SnakeCasePipe,
} from './components/metaview/addedit/addedit.component';
import { AddEditFieldComponent } from './components/metaview/addedit/addeditfield/addeditfield.component';
import { TableComponent } from './components/metaview/table/table.component';
import { EditApproverDialogComponent } from './components/modal/editapproverdialog/editapproverdialog.component';
import { EditCompanyDialogComponent } from './components/modal/editcompanydialog/editcompanydialog.component';
import { EditDateDialogComponent } from './components/modal/editdatedialog/editdatedialog.component';
import { EditProgramDialogComponent } from './components/modal/editprogramdialog/editprogramdialog.component';
import { ImageDialogComponent } from './components/modal/imagedialog/imagedialog.component';
import { IntroDialogComponent } from './components/modal/introdialog/introdialog.component';
import { LoginMemberComponent } from './components/modal/loginmemberdialog/login-member.page';
import { SendFundsComponent } from './components/modal/sendfundsdialog/send-funds-dialog.page';
import { SetTeamCompanyDialogComponent } from './components/modal/setteamcompanydialog/setteamcompanydialog.component';
import { SetTeamPrivacyDialogComponent } from './components/modal/setteamprivacydialog/setteamprivacydialog.component';
import { UploadRewardsComponent } from './components/modal/uploadrewardsdialog/uploadrewardsdialog.page';
import { ProgramComponent } from './components/program/program.page';
import { PurchasesComponent } from './components/purchases/purchases.component';
import { SnackBarComponent } from './components/snackbar/snackbar.component';
import { StripeChargehistoryComponent } from './components/stripe-chargehistory/stripe-chargehistory.component';
import { TeamCompaniesComponent } from './components/team-companies/team-companies.component';
// import {TooltipModule} from 'ng2-tooltip-directive';
// import {NgxLiquidCacheModule} from 'ngx-liquid-cache';
import { MatTreeModule } from '@angular/material/tree';
import { NgIdleModule } from '@ng-idle/core';
import { CodeInputModule } from 'angular-code-input';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import { AdminActionsComponent } from './components/admin-actions/admin-actions.component';
import { AnalyticsAllowancesComponent } from './components/analytics/analytics-allowances/analytics-allowances.component';
import { AnalyticsPeerToPeerComponent } from './components/analytics/analytics-peer-to-peer/analytics-peer-to-peer.component';
import { AnalyticsTeamAllowancesComponent } from './components/analytics/analytics-team-allowances/analytics-team-allowances.component';
import { AnalyticsTeamOverviewComponent } from './components/analytics/analytics-team-overview/analytics-team-overview.component';
import { AllowancesHighchartsContainerComponent } from './components/analytics/common/allowances-highcharts-container/allowances-highcharts-container.component';
import { HighchartsContainerComponent } from './components/analytics/common/highcharts-container/highcharts-container.component';
import { MembersOverviewComponent } from './components/analytics/common/members-overview/members-overview.component';
import { AnalyticsAllocationReportComponent } from './components/analytics/reports/analytics-allocation-report/analytics-allocation-report.component';
import { AnalyticsAllowanceAllocationReportComponent } from './components/analytics/reports/analytics-allowance-allocation-report/analytics-allowance-allocation-report.component';
import { AnalyticsPaymentReportComponent } from './components/analytics/reports/analytics-payment-report/analytics-payment-report.component';
import { AnalyticsRewardsReportComponent } from './components/analytics/reports/analytics-rewards-report/analytics-rewards-report.component';
import { AnalyticsSpendingReportComponent } from './components/analytics/reports/analytics-spending-report/analytics-spending-report.component';
import { AgencyClientsComponent } from './components/brokeragency/agency-clients/agency-clients.component';
import { MembersComponent } from './components/brokeragency/agency-members/members.component';
import { ProducersComponent } from './components/brokeragency/agency-producers/producers.component';
import { AgencyProfileComponent } from './components/brokeragency/agency-profile/agency-profile.component';
import { AgencyComponent } from './components/brokeragency/agency/agency.component';
import { BrokerAgenciesComponent } from './components/brokeragency/broker-agencies/broker-agencies.component';
import { BrokerProductsComponent } from './components/brokeragency/broker-products/broker-products.component';
import { BrokerProfileComponent } from './components/brokeragency/broker-profile/broker-profile.component';
import { BrokerComponent } from './components/brokeragency/broker/broker.component';
import { ClientCensusComponent } from './components/brokeragency/client-census/client-census.component';
import { ClientEligibilityComponent } from './components/brokeragency/client-eligibility/client-eligibility.component';
import { ClientEnrollmentComponent } from './components/brokeragency/client-enrollment/client-enrollment.component';
import { ClientsComponent } from './components/brokeragency/clients/clients.component';
import { MemberAddeditComponent } from './components/brokeragency/member-addedit/member-addedit.component';
import { MemberEnrollComponent } from './components/brokeragency/member-enroll/member-enroll.component';
import { MemberManagerComponent } from './components/brokeragency/member-manager/member-manager.component';
import { ProductDetailsComponent } from './components/brokeragency/product-details/product-details.component';
import { ProvisioningTileComponent } from './components/brokeragency/provisioning-tile/provisioning-tile.component';
import { ProvisioningComponent } from './components/brokeragency/provisioning/provisioning.component';
import { VendorGroupsPlansComponent } from './components/brokeragency/vendor-groups-plans/vendor-groups-plans.component';
import { VendorGroupsProductsComponent } from './components/brokeragency/vendor-groups-products/vendor-groups-products.component';
import { VendorGroupsQuestionsComponent } from './components/brokeragency/vendor-groups-questions/vendor-groups-questions.component';
import { VendorGroupsRatesComponent } from './components/brokeragency/vendor-groups-rates/vendor-groups-rates.component';
import { VendorGroupsComponent } from './components/brokeragency/vendor-groups/vendor-groups.component';
import { CardComponent } from './components/card/card.component';
import { BrandsPageComponent } from './components/contentadmin/brands-page/brands-page.component';
import { VendorCompletedTransfersPageComponent } from './components/contentadmin/vendor-completed-transfers-page/vendor-completed-transfers-page.component';
import { VendorPendingTransfersPageComponent } from './components/contentadmin/vendor-pending-transfers-page/vendor-pending-transfers-page.component';
import { VendorProductsPageComponent } from './components/contentadmin/vendor-products-page/vendor-products-page.component';
import { VendorsPageComponent } from './components/contentadmin/vendors-page/vendors-page.component';
import { ManagesupportagentsComponent } from './components/customersupport/managesupportagents/managesupportagents.component';
import { ManageusersComponent } from './components/customersupport/manageusers/manageusers.component';
import { PlaidSandboxToolDialogComponent } from './components/customersupport/manageusers/plaid-sandbox-tool-dialog.component';
import { ReportsComponent } from './components/customersupport/reports/reports.component';
import { EmailCodeComponent } from './components/email-code/email-code.component';
import { EnvSyncComponent } from './components/env-sync/env-sync.component';
import { Convert834Component } from './components/convert-834';
import { JsonDiffComponent } from './components/env-sync/json-diff/json-diff.component';
import { SchemaComparisonComponent } from './components/env-sync/schema-comparison/schema-comparison.component';
import { BrokeradminComponent } from './components/externalbrokeradmin/brokeradmin.component';
import { JsonEditorDialogComponent } from './components/form-fields/json/json-editor-dialog.component';
import { JsonComponent } from './components/form-fields/json/json.component';
import { StateComponent } from './components/form-fields/state/state.component';
import { GuidPickerButtonComponent } from './components/guid-picker/guid-picker-button.component';
import { GuidPickerDialogComponent } from './components/guid-picker/guid-picker-dialog.component';
import { SuperadminUsersComponent } from './components/superadmin/users/superadmin-users.component';
import { SuperadminUsersDetailComponent } from './components/superadmin/users/tabs/superadmin-users-detail.component';
import { SuperadminUsersPushComponent } from './components/superadmin/users/tabs/superadmin-users-push.component';
import { SuperadminUsersBlacklistComponent } from './components/superadmin/users/tabs/superadmin-users-blacklist.component';
import { SuperadminUsersSubscriptionDunningComponent } from './components/superadmin/users/tabs/superadmin-users-subscription-dunning.component';
import { SuperadminUsersDwollaComponent } from './components/superadmin/users/details/superadmin-users-dwolla.component';
import {
  SuperadminUsersStripePaymentsDialogComponent,
  SuperadminUsersStripeRefundDetailsDialogComponent,
  SuperadminUsersStripeRefundDialogComponent,
} from './components/superadmin/users/details/superadmin-users-stripe-payments-dialog.component';
import { ManageScopedAccessDialogComponent } from './components/superadmin/users/manage-scoped-access-dialog.component';
import { AssociateCompanyRoleDialogComponent } from './components/superadmin/users/associate-company-role-dialog.component';
import { UserTeamMembershipsDialogComponent } from './components/superadmin/users/user-team-memberships-dialog.component';
import { SuperadminRewardsComponent } from './components/superadmin/rewards/superadmin-rewards.component';
import { SuperadminRewardsListComponent } from './components/superadmin/rewards/tabs/superadmin-rewards-list.component';
import { SuperadminRewardsRebatesComponent } from './components/superadmin/rewards/tabs/superadmin-rewards-rebates.component';
import { SuperadminRewardsBrandsComponent } from './components/superadmin/rewards/tabs/superadmin-rewards-brands.component';
import { SuperadminRewardsCampaignsComponent } from './components/superadmin/rewards/tabs/superadmin-rewards-campaigns.component';
import { SuperadminRewardsClaimedComponent } from './components/superadmin/rewards/tabs/superadmin-rewards-claimed.component';
import { SuperadminRewardDetailComponent } from './components/superadmin/rewards/details/superadmin-reward-detail.component';
import { SuperadminBrandDetailComponent } from './components/superadmin/rewards/details/superadmin-brand-detail.component';
import { SuperadminCampaignDetailComponent } from './components/superadmin/rewards/details/superadmin-campaign-detail.component';
import { SuperadminClaimedDetailComponent } from './components/superadmin/rewards/details/superadmin-claimed-detail.component';
import { SuperadminRebateDetailComponent } from './components/superadmin/rewards/details/superadmin-rebate-detail.component';
import { SuperadminClaimedRewardComponent } from './components/superadmin/rewards/details/superadmin-claimed-reward.component';
import { SuperadminImportRewardsComponent } from './components/superadmin/rewards/details/superadmin-import-rewards.component';
import { SuperadminExportRewardsComponent } from './components/superadmin/rewards/details/superadmin-export-rewards.component';
import { BidirectionalSelectionComponent } from './components/superadmin/rewards/details/bidirectional-selection/bidirectional-selection.component';
import { CobrandingListComponent } from './components/superadmin/cobranding/cobranding-list.component';
import { CobrandingFormComponent } from './components/superadmin/cobranding/cobranding-form.component';
import { BrandDomainsComponent } from './components/superadmin/brand-domains/brand-domains.component';
import { AddBrandDomainDialogComponent } from './components/superadmin/brand-domains/add-brand-domain-dialog.component';
import { JsonConfigComponent } from './components/superadmin/json-config/json-config.component';
import { ComparedJsonConfigsComponent } from './components/superadmin/json-config/compared-json-configs.component';
import { ManagedFeatureFlagsComponent } from './components/superadmin/managed-feature-flags/managed-feature-flags.component';
import { ManagedFeatureFlagsListComponent } from './components/superadmin/managed-feature-flags-list/managed-feature-flags-list.component';
import { ManagedFeatureFlagsComparisonComponent } from './components/superadmin/managed-feature-flags-comparison/managed-feature-flags-comparison.component';
import { AiAssistantComponent } from './components/superadmin/ai-assistant/ai-assistant.component';
import { InboundSftpAccessComponent } from './components/superadmin/inbound-file-feeds/inbound-sftp-access.component';
import { InboundFileFeedsComponent } from './components/superadmin/inbound-file-feeds/inbound-file-feeds.component';
import { SensitiveDataAccessComponent } from './components/superadmin/sensitive-data-access/sensitive-data-access.component';
import { ProductClickEventsComponent } from './components/superadmin/product-click-events/product-click-events.component';
import { ObservabilityComponent } from './components/observability/observability.component';
import { FinanceContractsComponent } from './components/financeadmin/contracts/finance-contracts.component';
import { FinanceFundsMovementsComponent } from './components/financeadmin/funds-movements/finance-funds-movements.component';
import { FinanceInvoicesComponent } from './components/financeadmin/invoices/finance-invoices.component';
import { FinanceLedgerComponent } from './components/financeadmin/ledger/finance-ledger.component';
import { LedgerTransactionDialogComponent } from './components/financeadmin/ledger/ledger-transaction-dialog.component';
import { OpeningBalancesDialogComponent } from './components/financeadmin/ledger/opening-balances-dialog.component';
import { FinanceReportsComponent } from './components/financeadmin/reports/finance-reports.component';
import { FinanceSettlementsComponent } from './components/financeadmin/settlements/finance-settlements.component';
import { BankReconciliationComponent } from './components/financeadmin/bank-reconciliation/bank-reconciliation.component';
import { FinanceConnectionsComponent } from './components/financeadmin/connections/finance-connections.component';
import { VisibleFinanceTabsPipe } from './components/financeadmin/finance-tabs.pipe';
import { ImageuploadComponent } from './components/imageupload/imageupload/imageupload.component';
import { InfobandComponent } from './components/infoband/infoband.component';
import { InlinemessageComponent } from './components/inlinemessage/inlinemessage.component';
import { InsuranceBeneficiariesComponent } from './components/insurance-beneficiaries/insurance-beneficiaries.component';
import { InsuranceDependentsComponent } from './components/insurance-dependents/insurance-dependents.component';
import { InsurancePrimaryComponent } from './components/insurance-primary/insurance-primary.component';
import { InsuranceProfileComponent } from './components/insuranceprofile/insuranceprofile.component';
import { ListInputComponent } from './components/list-input/list-input.component';
import { GroupFilterComponent } from './components/marketing-campaigns/group-filter/group-filter.component';
import { MarketingCampaignsComponent } from './components/marketing-campaigns/marketing-campaigns.component';
import { MarketingCampaignsGroupsComponent } from './components/marketing-campaigns/tabs/marketing-campaigns-groups/marketing-campaigns-groups.component';
import { MarketingCampaignsHistoryComponent } from './components/marketing-campaigns/tabs/marketing-campaigns-history/marketing-campaigns-history.component';
import { MarketingCampaignsListComponent } from './components/marketing-campaigns/tabs/marketing-campaigns-list/marketing-campaigns-list.component';
import { MarketingCampaignsSequencesComponent } from './components/marketing-campaigns/tabs/marketing-campaigns-sequences/marketing-campaigns-sequences.component';
import { AdduserdialogComponent } from './components/modal/adduserdialog/adduserdialog.component';
import { CarrierftpdialogComponent } from './components/modal/carrierftpdialog/carrierftpdialog.component';
import { EditUserEmailDialogComponent } from './components/modal/edituseremaildialog/edituseremaildialog.component';
import { ChangePartnerDialogComponent } from './components/modal/changepartnerdialog/changepartnerdialog.component';
import { ClientsDialogComponent } from './components/modal/clientsdialog/clientsdialog.component';
import { CompanyProductsDialogComponent } from './components/modal/companyproductsdialog/companyproductsdialog.component';
import { CompanyProductTilesCategoriesDialogComponent } from './components/modal/company-product-tiles-categories-dialog/company-product-tiles-categories-dialog.component';
import { CompanySnackRewardsDialogComponent } from './components/modal/company-snack-rewards-dialog/company-snack-rewards-dialog.component';
import { CompanyProductPayrollBenefitCategoriesDialogComponent } from './components/modal/company-product-payroll-benefit-categories-dialog/company-product-payroll-benefit-categories-dialog.component';
import { CompanyProductPlanLevelsDialogComponent } from './components/modal/company-product-plan-levels-dialog/company-product-plan-levels-dialog.component';
import { ClawbackRewardDialogComponent } from './components/modal/clawbackrewarddialog/clawbackrewarddialog.component';
import { CustomerLinkModalComponent } from './components/modal/customer-link-modal/customer-link-modal.component';
import { CustomMonthlyAllowanceComponent } from './components/modal/custommonthlyallowance/custommonthlyallowance.component';
import { EditCompanyManagersDialogComponent } from './components/modal/editcompanymanagersdialog/editcompanymanagersdialog.component';
import { GetUserDialogComponent } from './components/modal/getuserdialog/getuserdialog.component';
import { LoginlistdialogComponent } from './components/modal/loginlistdialog/loginlistdialog.component';
import { MovieDialogComponent } from './components/modal/moviedialog/moviedialog.component';
import { NewClientDialogComponent } from './components/modal/new-client-dialog/new-client-dialog.component';
import { RefundAllowanceDialogComponent } from './components/modal/refundallowancedialog/refundallowancedialog.component';
import { SetInvoicingDialogComponent } from './components/modal/setinvoicingdialog/setinvoicingdialog.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { ProductsCompaniesComponent } from './components/products-companies/products-companies.component';
import { ProductsPermissionsComponent } from './components/products-permissions/products-permissions.component';
import { ProductsPurchasesComponent } from './components/products-purchases/products-purchases.component';
import { ReconciliationApilogComponent } from './components/reconciliation-apilog/reconciliation-apilog.component';
import { ReconciliationStripeComponent } from './components/reconciliation-stripe/reconciliation-stripe.component';
import { ReconciliationTeamlogComponent } from './components/reconciliation-teamlog/reconciliation-teamlog.component';
import { ReconciliationComponent } from './components/reconciliation/reconciliation.component';
import { SendInvitesButtonComponent } from './components/send-invites-button/send-invites-button.component';
import { SendInvitesScheduleDialogComponent } from './components/send-invites-button/send-invites-schedule-dialog.component';
import { StripeAvailablePaymentMethodsComponent } from './components/stripe-available-payment-methods/stripe-available-payment-methods.component';
import { StripeChargehistoryTableComponent } from './components/stripe-chargehistory/stripe-chargehistory-table/stripe-chargehistory-table.component';
import { StripePaymentMethodsComponent } from './components/stripepaymentmethods/stripepaymentmethods.component';
import { TagsComponent } from './components/tags/tags.component';
import { BillingCycleFormComponent } from './components/vendor-products/forms/billing-cycle-form/billing-cycle-form.component';
import { BillingCycleModalComponent } from './components/vendor-products/modals/billing-cycle-modal/billing-cycle-modal.component';
import { VendorProductsBrandListComponent } from './components/vendor-products/tabs/vendor-products-brand-list/vendor-products-brand-list.component';
import { StripeProductFormComponent } from './components/vendor-products/tabs/vendor-products-product-list/details/vendor-product-details/forms/stripe-product-form/stripe-product-form.component';
import { VendorProductFormComponent } from './components/vendor-products/tabs/vendor-products-product-list/details/vendor-product-details/forms/vendor-product-form/vendor-product-form.component';
import { BrandsTableComponent } from './components/vendor-products/tabs/vendor-products-product-list/details/vendor-product-details/tables/brands-table/brands-table.component';
import { VendorProductDetailsComponent } from './components/vendor-products/tabs/vendor-products-product-list/details/vendor-product-details/vendor-product-details.component';
import { VendorProductsProductListComponent } from './components/vendor-products/tabs/vendor-products-product-list/vendor-products-product-list.component';
import { VendorProductsComponent } from './components/vendor-products/vendor-products.component';
import { VendorProductsStripeProductsComponent } from './components/vendor-products/tabs/vendor-products-stripe-products/vendor-products-stripe-products.component';
import { VendorProductsUserProductsComponent } from './components/vendor-products/tabs/vendor-products-user-products/vendor-products-user-products.component';
import { VendorProductsApiLogComponent } from './components/vendor-products/tabs/vendor-products-api-log/vendor-products-api-log.component';
import { VendorProductsWebhooksComponent } from './components/vendor-products/tabs/vendor-products-webhooks/vendor-products-webhooks.component';
import { VendorProductsWebhookDetailDialogComponent } from './components/vendor-products/tabs/vendor-products-webhooks/details/vendor-products-webhook-detail-dialog.component';
import { MatBasicSpinnerDirective } from './directives/mat-basic-spinner.directive';
import { ApiService } from './services/api/api.service';
import { BrandDomainsService } from './services/brand-domain/brand-domain.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpInterceptorProvider } from './interceptors/http-interceptor';
import { ProductsTableComponent } from './components/vendor-products/tabs/vendor-products-brand-list/tables/products-table/products-table.component';
import { EditPurchasePageComponent } from './components/purchases/edit-purchase/edit-purchase.page';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import {BrandsService} from './services/brands/brands.service';
import { PayrollConnectionsComponent } from './components/payrolladmin/payroll-connections/payroll-connections.component';
import { PayrollDashboardsComponent } from './components/payrolladmin/payroll-dashboards/payroll-dashboards.component';
import { PayrollProductsComponent } from './components/payrolladmin/payroll-products/payroll-products.component';
import { PayrollDeductionsComponent } from './components/payrolladmin/payroll-deductions/payroll-deductions.component';
import { PayrollReportsComponent } from './components/payrolladmin/payroll-reports/payroll-reports.component';
import { PayrollReportRerunDialogComponent } from './components/payrolladmin/payroll-reports/payroll-report-rerun-dialog.component';
import { PayrollSensitiveReportPreviewDialogComponent } from './components/payrolladmin/payroll-reports/payroll-sensitive-report-preview-dialog.component';
import { PayrollReportSftpSecretDialogComponent } from './components/payrolladmin/payroll-reports/payroll-report-sftp-secret-dialog.component';
import { PayrollDashboardSendReportDialogComponent } from './components/payrolladmin/payroll-dashboards/payroll-dashboard-send-report-dialog.component';
import { PayrollDashboardReportParametersDialogComponent } from './components/payrolladmin/payroll-dashboards/payroll-dashboard-report-parameters-dialog.component';
import { PayrollDashboardComponent } from './components/payrolladmin/payroll-dashboard/payroll-dashboard.component';
import {PayrollVendorComponent} from './components/payrolladmin/payroll-vendors/payroll-vendors.component';
import { AdminFeesPageComponent } from './components/contentadmin/admin-fees-page/admin-fees-page.component';
import { AdminFeeEditorDialogComponent } from './components/contentadmin/admin-fees-page/admin-fee-editor-dialog/admin-fee-editor-dialog.component';
import { ObjectViewerComponent } from './components/object-viewer/object-viewer.component';
import { PayrollTeamsComponent } from './components/payrolladmin/payroll-teams/payroll-teams.component';
import {PayrollTeamSettingsComponent, PayrollTeamSettingsDialogComponent} from './components/payrolladmin/payroll-team-settings/payroll-team-settings.component';
import { PayrollWorkforceCriteriaComponent } from './components/payrolladmin/payroll-workforce-criteria/payroll-workforce-criteria.component';
import { PayrollWorkforceBrowseComponent } from './components/payrolladmin/payroll-workforce-browse/payroll-workforce-browse.component';
import { PayrollExpenseApprovalsComponent } from './components/payrolladmin/payroll-expense-approvals/payroll-expense-approvals.component';
import { EditTeamDialogComponent } from './components/payrolladmin/edit-team-dialog/edit-team-dialog.component';
import { EditBenefitsDialogComponent } from './components/payrolladmin/edit-benefits-dialog/edit-benefits-dialog.component';
import { EditTeamSnacksDialogComponent } from './components/payrolladmin/edit-team-snacks-dialog/edit-team-snacks-dialog.component';
import { SnackRewardPreviewComponent } from './components/payrolladmin/snack-reward-preview/snack-reward-preview.component';
import { CustomReimbursementRolloverResolutionDialogComponent } from './components/payrolladmin/edit-benefits-dialog/custom-reimbursement-rollover-resolution-dialog.component';
import { GroupProductOnboardingRequestDialogComponent } from './components/payrolladmin/group-product-onboarding-request-dialog/group-product-onboarding-request-dialog.component';
import { PayrollConnectionDialogComponent } from './components/payrolladmin/payroll-connection-dialog/payroll-connection-dialog.component';
import { StepDialogFooterDefaultTemplateDirective, StepDialogFooterTemplateDirective, StepDialogShellComponent, StepDialogStepTemplateDirective } from './components/payrolladmin/step-dialog/step-dialog-shell.component';
import { SendInvitesDialogComponent } from './components/payrolladmin/send-invites-dialog/send-invites-dialog.component';
import { EmployeeDetailsDialogComponent } from './components/payrolladmin/employee-details-dialog/employee-details-dialog.component';
import { TerminationReviewDialogComponent } from './components/payrolladmin/termination-review-dialog/termination-review-dialog.component';
import { ComingSoonUpsellComponent } from './components/payrolladmin/coming-soon-upsell/coming-soon-upsell.component';
import { DisabledFeatureUpsellComponent } from './components/payrolladmin/disabled-feature-upsell/disabled-feature-upsell.component';
import { PayrollCompanyComponent } from './components/payrolladmin/payroll-company/payroll-company.component';
import { PayrollCompanyDialogComponent } from './components/payrolladmin/payroll-company-dialog/payroll-company-dialog.component';
import { PayrollBrokerDialogComponent } from './components/payrolladmin/payroll-broker-dialog/payroll-broker-dialog.component';
import { GroupProductOnboardingStatusDialogComponent } from './components/products-companies/group-product-onboarding-status-dialog/group-product-onboarding-status-dialog.component';

export function appInit(appConfigService: BrandsService): () => Promise<void> {
  return async () => appConfigService.init();
}

const restangularUnauthorizedState = {
  redirectInProgress: false,
};
const restangularRefresh = new CredentialRefresh(TabStorageService.credentials);

const jwtHelper = new JwtHelperService();
const ABSOLUTE_SESSION_EXPIRATION_CLAIM = 'sessionAbsoluteExp';

const isAbsoluteSessionExpired = (token: string | null): boolean => {
  if (!token) {
    return true;
  }

  try {
    const decodedToken = jwtHelper.decodeToken(token);
    const absoluteExpiration = Number(decodedToken?.[ABSOLUTE_SESSION_EXPIRATION_CLAIM]);
    return !Number.isFinite(absoluteExpiration) || absoluteExpiration <= Math.floor(Date.now() / 1000);
  } catch (_) {
    return true;
  }
};

const hasRequiredExpirationClaim = (token: string | null): boolean => {
  if (!token) {
    return false;
  }

  const decodedToken = jwtHelper.decodeToken(token);
  return Boolean(decodedToken && Number.isFinite(Number(decodedToken.exp)));
};

const hasValidStoredJwtToken = (): boolean => {
  const token = TabStorageService.getStorage(TabStorageService.JWT_TOKEN);
  if (!token) {
    return false;
  }

  try {
    return hasRequiredExpirationClaim(token) && !isAbsoluteSessionExpired(token) && !jwtHelper.isTokenExpired(token);
  } catch (_) {
    return false;
  }
};

const shouldForceLogout = (response: any): boolean => {
  const status = response?.status;
  if (status === 401) {
    return true;
  }

  if (status === 403) {
    return !hasValidStoredJwtToken();
  }

  return false;
};

const getRestangularRequestUrl = (response: any): string => {
  return response?.request?.url || response?.config?.url || response?.url || '';
};

const isWallitApiRequestUrl = (requestUrl: string): boolean => {
  if (!requestUrl || !/^https?:\/\//i.test(requestUrl)) {
    return true;
  }

  try {
    const requestHost = new URL(requestUrl).host;
    const endpointHost = new URL(AppSettings.getEndpoint()).host;
    return requestHost === endpointHost || requestHost.endsWith('.api.wallit.app');
  } catch (_) {
    return requestUrl.startsWith(AppSettings.getEndpoint());
  }
};

const shouldAttemptRestangularRefresh = (response: any): boolean => {
  const requestUrl = getRestangularRequestUrl(response);
  return Boolean(
    response?.status === 401 &&
    isWallitApiRequestUrl(requestUrl) &&
    TabStorageService.getStorage(TabStorageService.JWT_TOKEN) &&
    hasRequiredExpirationClaim(TabStorageService.getStorage(TabStorageService.JWT_TOKEN)) &&
    TabStorageService.getStorage(TabStorageService.REFRESH_TOKEN) &&
    !isAbsoluteSessionExpired(TabStorageService.getStorage(TabStorageService.JWT_TOKEN)) &&
    !requestUrl.includes('/auth') &&
    !requestUrl.includes('globalconfig.api') &&
    !requestUrl.includes('infra-mgmt.api') &&
    !requestUrl.includes('be-playground.api') &&
    !requestUrl.includes(AppSettings.getIntegrationEndpoint())
  );
};

const refreshStoredJwtToken = (context?: CredentialContext): Promise<any> =>
  restangularRefresh.run(() => !context || context.current(), context);

// A late failure may only clear the credentials actually used by that still-current request.
const canClearRequestCredentials = (context: CredentialContext | null, response: any): boolean => {
  if (!context) { return true; }
  const sent = response?.request?.headers?.get('Authorization') || `Bearer ${context.token}`;
  return context.current() && sent === `Bearer ${TabStorageService.getStorage(TabStorageService.JWT_TOKEN)}`;
};

const withCurrentJwtToken = (request: any): any => {
  const token = TabStorageService.getStorage(TabStorageService.JWT_TOKEN);
  return token && request?.clone
    ? request.clone({headers: request.headers.set('Authorization', `Bearer ${token}`)})
    : request;
};

const repeatRestangularRequest = (response: any): any => {
  if (!response?.repeatRequest) {
    return null;
  }

  const requestWithFreshToken = withCurrentJwtToken(response.request);
  return response.request
    ? response.repeatRequest(requestWithFreshToken)
    : response.repeatRequest();
};

const forceLogout = (): void => {
  if (restangularUnauthorizedState.redirectInProgress) {
    return;
  }
  restangularUnauthorizedState.redirectInProgress = true;
  TabStorageService.clearCurrentTabSession();
  window.location.assign('/login/false');
};

function RestangularConfigFactory(RestangularProvider: any, router: any): void {
  RestangularProvider.setBaseUrl(AppSettings.getEndpoint());
  TabStorageService.credentials.subscribe(token => RestangularProvider.setDefaultHeaders(token ? {Authorization: `Bearer ${token}`} : {}));
  RestangularProvider.addResponseInterceptor(
    (data: any, operation: any, what: any, url: any, response: any) => {
      ApiService.spinnerDecrement();
      return data;
    },
  );

  RestangularProvider.setRequestInterceptor((elem: any, operation: any) => {
    ApiService.spinnerIncrement();
    return elem;
  });

  RestangularProvider.addErrorInterceptor((response: any, subject: any, responseHandler: any) => {
    ApiService.spinnerDecrement();
    const context: CredentialContext | null = response?.request?.context?.get(CREDENTIAL_REQUEST) || null;
    if (context && !context.current()) {
      subject.error(new Error('Request session context changed'));
      return false;
    }
    if (response.status === 401) {
      if (shouldAttemptRestangularRefresh(response)) {
        refreshStoredJwtToken(context || undefined)
          .then(() => {
            if (context && !context.current()) { throw new Error('Request session context changed'); }
            const retryRequest = repeatRestangularRequest(response);
            if (!retryRequest) {
              if (canClearRequestCredentials(context, response)) { forceLogout(); }
              subject.error(response);
              return;
            }

            retryRequest.subscribe(
              (res: any) => responseHandler(res),
              (err: any) => {
                subject.error(err);
                if (canClearRequestCredentials(context, err)) { forceLogout(); }
              },
            );
          })
          .catch((err: any) => {
            subject.error(err);
            if (canClearRequestCredentials(context, null)) { forceLogout(); }
          });
        return false;
      }
      forceLogout();
      return false;
    }

    if (response.status === 403) {
      if (!hasValidStoredJwtToken()) {
        forceLogout();
        return false;
      }
      return true;
    }

    return true;
  });
}

export const RestangularIntegrationFactory = (restangular: Restangular) =>
  restangular.withConfig((RestangularConfigurer: any) => {
    RestangularConfigurer.setBaseUrl(AppSettings.getIntegrationEndpoint());
    RestangularConfigurer.addResponseInterceptor(
      (data: any, operation: any, what: any, url: any, response: any) => {
        ApiService.spinnerDecrement();
        return data;
      },
    );
    RestangularConfigurer.setRequestInterceptor((elem: any, operation: any) => {
      ApiService.spinnerIncrement();
      return elem;
    });
    RestangularConfigurer.addErrorInterceptor(
      (response: any, subject: any, responseHandler: any) => {
        ApiService.spinnerDecrement();
        if (shouldForceLogout(response)) {
          forceLogout();
        }
      },
    );
  });

const allModules = [
  MatToolbarModule,
  MatCardModule,
  MatInputModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatSelectModule,
  MatCheckboxModule,
  MatIconModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatChipsModule,
  MatSidenavModule,
  MatListModule,
  MatProgressBarModule,
  MatBottomSheetModule,
  MatBadgeModule,
  MatProgressSpinnerModule,
  MatDatepickerModule,
  MatGridListModule,
  MatNativeDateModule,
  MatRippleModule,
  MatAutocompleteModule,
  MatTooltipModule,
  MatMenuModule,
  MatPaginatorModule,
  MatDialogModule,
  MatTabsModule,
  MatTableModule,
  MatSortModule,
  DragDropModule,
  MatSliderModule,
  MatRadioModule,
  MatStepperModule,
  MatSlideToggleModule,
  CdkStepperModule,
  CdkScrollableModule,
  HttpClientModule,
  BrowserModule,
  AppRoutingModule,
  BrowserAnimationsModule,
  ReactiveFormsModule,
  FormsModule,
  CommonModule,
  MatTableExporterModule,
  NgxMatSelectSearchModule,
  MatSnackBarModule,
  NgJsonEditorModule,
  WebdatarocksPivotModule,
  NgxDropzoneModule,
  // TooltipModule,
  ColorPickerModule,
  MatBasicSpinnerDirective,
  MatOptionModule,
];

@NgModule({
  declarations: [
    ObservabilityComponent,
    GetStatePipe,
    GetStatusPipe,
    GetUserNameReimbursements,
    GetSenderNameReimbursements,
    TaxableFilterPipe,
    SnakeCasePipe,
    AppComponent,
    VersionGateDialogComponent,
    AnalyticsComponent,
    HomeComponent,
    ManageMembersComponent,
    InvitationsComponent,
    AdManagerComponent,
    ProfileComponent,
    ManageWellspaceComponent,
    MyTeamComponent,
    TeamSummaryComponent,
    ManageWellspaceProductsComponent,
    CategoriesComponent,
    SettingsAndPermissionsComponent,
    LoginComponent,
    SignUpComponent,
    TeampaymentsComponent,
    TeameditComponent,
    ConfirmDialogComponent,
    AllowanceFundingAmountDialogComponent,
    MonthlyTopupScheduleComponent,
    UserItemComponent,
    MemberProductEligibilityDialogComponent,
    TeamSetBenefitsPageComponent,
    TeamAddMembersPageComponent,
    StripecreditcardPageComponent,
    FieldInputDialogComponent,
    PlanComponent,
    ProgramComponent,
    TeamOneTimeRewardComponent,
    MemberRewardDialogComponent,
    RefundAllowanceDialogComponent,
    ClawbackRewardDialogComponent,
    TeamMemberSelectorComponent,
    EnterPinDialogComponent,
    AnalyticsOverviewComponent,
    AnalyticsCategoriesComponent,
    AnalyticsMembersComponent,
    AnalyticsToapproveComponent,
    FileuploadComponent,
    BillingComponent,
    StripeChargehistoryComponent,
    SendFundsComponent,
    UploadRewardsComponent,
    LoginMemberComponent,
    EditProgramDialogComponent,
    EditDateDialogComponent,
    AnalyticsReimbursementsComponent,
    AnalyticsApproveComponent,
    PurchasesComponent,
    IntroDialogComponent,
    SnackBarComponent,
    AnalyticsConfigureComponent,
    EditApproverDialogComponent,
    EditUserEmailDialogComponent,
    ChangePartnerDialogComponent,
    ImageDialogComponent,
    TeamCompaniesComponent,
    EditCompanyDialogComponent,
    SetTeamCompanyDialogComponent,
    SetTeamPrivacyDialogComponent,
    IntegrationHomeComponent,
    InsuranceUsersComponent,
    InsuranceCarriersComponent,
    InsuranceBrokersComponent,
    InsuranceEmployersComponent,
    AdvertisingAdvertisersComponent,
    AdvertisingAdsComponent,
    AdvertisingCreativesComponent,
    AdvertisingFlightsComponent,
    AdvertisingImpressionsComponent,
    AdvertisingCampaignsComponent,
    TableComponent,
    AddEditDialogComponent,
    AddEditFieldComponent,
    MediaImagesComponent,
    MediaDocumentsComponent,
    MediaContentComponent,
    PaginatorComponent,
    AdminActionsComponent,
    TagsComponent,
    ProductsCompaniesComponent,
    GroupProductOnboardingStatusDialogComponent,
    ProductsPurchasesComponent,
    AnalyticsAllowancesComponent,
    ReconciliationComponent,
    ReconciliationStripeComponent,
    ReconciliationTeamlogComponent,
    ReconciliationApilogComponent,
    SetInvoicingDialogComponent,
    StripePaymentMethodsComponent,
    BrokeradminComponent,
    EditCompanyManagersDialogComponent,
    ProductsPermissionsComponent,
    InsuranceProfileComponent,
    InsurancePrimaryComponent,
    InsuranceDependentsComponent,
    InsuranceBeneficiariesComponent,
    HighchartsContainerComponent,
    AnalyticsTeamOverviewComponent,
    MembersOverviewComponent,
    EmailCodeComponent,
    StripeAvailablePaymentMethodsComponent,
    AllowancesHighchartsContainerComponent,
    AnalyticsTeamAllowancesComponent,
    ManageusersComponent,
    PlaidSandboxToolDialogComponent,
    ManagesupportagentsComponent,
    AdduserdialogComponent,
    LoginlistdialogComponent,
    CustomerLinkModalComponent,
    NewClientDialogComponent,
    AnalyticsPeerToPeerComponent,
    MovieDialogComponent,
    ReportsComponent,
    BrokerComponent,
    AgencyComponent,
    ClientsComponent,
    MembersComponent,
    ProducersComponent,
    ClientCensusComponent,
    ClientEligibilityComponent,
    ClientEnrollmentComponent,
    AgencyProfileComponent,
    BrokerProfileComponent,
    BrokerAgenciesComponent,
    MemberManagerComponent,
    ImageuploadComponent,
    BrokerProductsComponent,
    MemberAddeditComponent,
    CompanyProductsDialogComponent,
    CompanyProductTilesCategoriesDialogComponent,
    CompanySnackRewardsDialogComponent,
    CompanyProductPayrollBenefitCategoriesDialogComponent,
    CompanyProductPlanLevelsDialogComponent,
    AgencyClientsComponent,
    InlinemessageComponent,
    ProductDetailsComponent,
    ClientsDialogComponent,
    InfobandComponent,
    MemberEnrollComponent,
    StateComponent,
    VendorGroupsComponent,
    VendorGroupsRatesComponent,
    VendorGroupsProductsComponent,
    VendorGroupsPlansComponent,
    JsonEditorDialogComponent,
    JsonComponent,
    GetUserDialogComponent,
    ProvisioningComponent,
    ProvisioningTileComponent,
    AnalyticsPaymentReportComponent,
    AnalyticsAllowanceAllocationReportComponent,
    AnalyticsSpendingReportComponent,
    AnalyticsRewardsReportComponent,
    AnalyticsAllocationReportComponent,
    VendorGroupsQuestionsComponent,
    StripeChargehistoryTableComponent,
    MarketingCampaignsComponent,
    MarketingCampaignsHistoryComponent,
    MarketingCampaignsGroupsComponent,
    MarketingCampaignsListComponent,
    MarketingCampaignsSequencesComponent,
    CarrierftpdialogComponent,
    GroupFilterComponent,
    ListInputComponent,
    CardComponent,
    EnvSyncComponent,
    Convert834Component,
    SchemaComparisonComponent,
    JsonDiffComponent,
    BrandsPageComponent,
    VendorsPageComponent,
    CustomMonthlyAllowanceComponent,
    VendorProductsPageComponent,
    VendorPendingTransfersPageComponent,
    VendorCompletedTransfersPageComponent,
    SendInvitesButtonComponent,
    SendInvitesScheduleDialogComponent,
    VendorProductsComponent,
    EditPurchasePageComponent,
    VendorProductsProductListComponent,
    VendorProductsStripeProductsComponent,
    VendorProductsUserProductsComponent,
    VendorProductsApiLogComponent,
    VendorProductsWebhooksComponent,
    VendorProductsWebhookDetailDialogComponent,
    VendorProductDetailsComponent,
    StripeProductFormComponent,
    VendorProductFormComponent,
    BrandsTableComponent,
    BillingCycleFormComponent,
    BillingCycleModalComponent,
    VendorProductsBrandListComponent,
    ProductsTableComponent,
    PayrollConnectionsComponent,
    PayrollCompanyComponent,
    PayrollProductsComponent,
    PayrollDeductionsComponent,
    PayrollReportsComponent,
    PayrollReportRerunDialogComponent,
    PayrollSensitiveReportPreviewDialogComponent,
    PayrollReportSftpSecretDialogComponent,
    PayrollDashboardSendReportDialogComponent,
    PayrollDashboardReportParametersDialogComponent,
    PayrollDashboardComponent,
    PayrollCompanyDialogComponent,
    PayrollBrokerDialogComponent,
    PayrollVendorComponent,
    AdminFeesPageComponent,
    AdminFeeEditorDialogComponent,
    ObjectViewerComponent,
    PayrollTeamsComponent,
    PayrollWorkforceBrowseComponent,
    PayrollWorkforceCriteriaComponent,
    PayrollTeamSettingsComponent,
    PayrollTeamSettingsDialogComponent,
    PayrollDashboardsComponent,
    PayrollExpenseApprovalsComponent,
    EditTeamDialogComponent,
    EditBenefitsDialogComponent,
    EditTeamSnacksDialogComponent,
    SnackRewardPreviewComponent,
    CustomReimbursementRolloverResolutionDialogComponent,
    GroupProductOnboardingRequestDialogComponent,
    PayrollConnectionDialogComponent,
    StepDialogShellComponent,
    SendInvitesDialogComponent,
    EmployeeDetailsDialogComponent,
    TerminationReviewDialogComponent,
    StepDialogFooterDefaultTemplateDirective,
    StepDialogStepTemplateDirective,
    StepDialogFooterTemplateDirective,
    ComingSoonUpsellComponent,
    DisabledFeatureUpsellComponent,
    GuidPickerButtonComponent,
    GuidPickerDialogComponent,
    SuperadminUsersComponent,
    SuperadminUsersDetailComponent,
    SuperadminUsersPushComponent,
    SuperadminUsersBlacklistComponent,
    SuperadminUsersSubscriptionDunningComponent,
    SuperadminUsersDwollaComponent,
    SuperadminUsersStripePaymentsDialogComponent,
    SuperadminUsersStripeRefundDetailsDialogComponent,
    SuperadminUsersStripeRefundDialogComponent,
    AssociateCompanyRoleDialogComponent,
    ManageScopedAccessDialogComponent,
    UserTeamMembershipsDialogComponent,
    SuperadminRewardsComponent,
    SuperadminRewardsListComponent,
    SuperadminRewardsRebatesComponent,
    SuperadminRewardsBrandsComponent,
    SuperadminRewardsCampaignsComponent,
    SuperadminRewardsClaimedComponent,
    SuperadminRewardDetailComponent,
    SuperadminBrandDetailComponent,
    SuperadminCampaignDetailComponent,
    SuperadminClaimedDetailComponent,
    SuperadminRebateDetailComponent,
    SuperadminClaimedRewardComponent,
    SuperadminImportRewardsComponent,
    SuperadminExportRewardsComponent,
    CobrandingListComponent,
    CobrandingFormComponent,
    AiAssistantComponent,
    BrandDomainsComponent,
    AddBrandDomainDialogComponent,
    JsonConfigComponent,
    ComparedJsonConfigsComponent,
    ManagedFeatureFlagsComponent,
    ManagedFeatureFlagsListComponent,
    ManagedFeatureFlagsComparisonComponent,
    InboundFileFeedsComponent,
    InboundSftpAccessComponent,
    SensitiveDataAccessComponent,
    ProductClickEventsComponent,
    FinanceContractsComponent,
    FinanceFundsMovementsComponent,
    FinanceSettlementsComponent,
    FinanceInvoicesComponent,
    FinanceReportsComponent,
    FinanceLedgerComponent,
    BankReconciliationComponent,
    FinanceConnectionsComponent,
    VisibleFinanceTabsPipe,
    LedgerTransactionDialogComponent,
    OpeningBalancesDialogComponent,
    BidirectionalSelectionComponent,
  ],
  imports: [
    OfferAudiencesComponent,
    VendorExportHealthComponent,
    UserProductsComponent,
    ...allModules,
    InfiniteScrollModule,
    RestangularModule.forRoot([Router], RestangularConfigFactory),
    // NgxLiquidCacheModule.forRoot({duration: 300}),
    MatTreeModule,
    NgxMatIntlTelInputComponent,
    CodeInputModule,
    NgIdleModule.forRoot(),
  ],
  providers: [
    {provide: RestangularHttp, useClass: CredentialRestangularHttp},
    {
      provide: RESTANGULAR_INTEGRATION_SERVER,
      useFactory: RestangularIntegrationFactory,
      deps: [Restangular],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInit,
      deps: [BrandsService, HttpClient],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorProvider,
      multi: true,
    },
    BrandDomainsService,

  ],
  exports: allModules,
  bootstrap: [AppComponent],
})
export class AppModule { }
